import { post } from "@utils/fetch";

type AuthenticateImpersonationTokenInput = {
  impersonationToken: string;
};

type AuthenticateImpersonationTokenResponse = {
  data: string;
};

export const authenticateImpersonationToken = async (
  input: AuthenticateImpersonationTokenInput,
): Promise<AuthenticateImpersonationTokenResponse> => {
  const { data } = await post(
    "/api/public/v1/auth/authenticate-impersonation-token/",
    input,
  );

  return data;
};